// A count of lessons as people say it: 3, 1½, ½. Whole everywhere except a
// studio that counts half lessons (LessonUnits on the server), where a lesson
// and a half uses 1½ of what someone bought.
export const lessonCount = (n) => {
  const value = Number(n) || 0;
  if (Number.isInteger(value)) return String(value);
  const sign = value < 0 ? "-" : "";
  const whole = Math.floor(Math.abs(value));
  return `${sign}${whole === 0 ? "" : whole}½`;
};

// "1 lesson", "1½ lessons", "3 lessons".
export const lessonsText = (n) => `${lessonCount(n)} ${Number(n) === 1 ? "lesson" : "lessons"}`;
